import { render, staticRenderFns } from "./transfertable.vue?vue&type=template&id=02cf7b33&scoped=true"
import script from "./transfertable.vue?vue&type=script&lang=js"
export * from "./transfertable.vue?vue&type=script&lang=js"
import style0 from "./transfertable.vue?vue&type=style&index=0&id=02cf7b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf7b33",
  null
  
)

export default component.exports